import { useProjectStore } from './projectStore.ts';

/** Returns true if mutation is blocked (read-only review mode) */
export function isReadOnly(): boolean {
  return useProjectStore.getState().readOnly;
}
